/**
 * 法人IDの正規表現
 */
export const CorporateIdRegExp = new RegExp(/^[a-zA-Z0-9]{4,30}$/);
export const CorporateConstraintMessage = '半角英数字の4文字以上30文字以内';

/**
 * ご担当者氏名の正規表現
 */
export const corporateRepresentativeRegExp = new RegExp(/^.{1,30}$/);
export const corporateRepresentativeLengthLimit = 30;
export const corporateRepresentativeConstraintErrorMessage = '1文字以上30文字以内';

/**
 * ご担当者氏名カナの正規表現
 */
export const corporateRepresentativeKanaRegExp = new RegExp(/^[ァ-ヶー　 ]{1,30}$/);
export const corporateRepresentativeKanaLengthLimit = 30;
export const corporateRepresentativeKanaConstraintErrorMessage = '全角カナの1文字以上30文字以内';

/**
 * 法人名の正規表現
 */
export const corporateNameRegExp = new RegExp(/^.{1,50}$/);
export const corporateNameLengthLimit = 50;
export const corporateNameConstraintErrorMessage = '1文字以上50文字以内';

/**
 * 法人名（カナ）の正規表現
 */
export const corporateNameKanaRegExp = new RegExp(/^[ァ-ヶー　]{1,50}$/);
export const corporateNameKanaLengthLimit = 50;
export const corporateNameKanaConstraintErrorMessage = '全角カナの1文字以上50文字以内';

/**
 * 部署名の正規表現
 */
export const divisionNameRegExp = new RegExp(/^.{0,30}$/);
export const divisionNameLengthLimit = 30;
export const divisionNameConstraintErrorMessage = '30文字以内';

/**
 * 携帯電話番号の正規表現
 */
export const authPhoneNumberRegExp = new RegExp(/^0\d{9}$/);
export const authPhoneNumberLengthLimit = 10;
export const authPhoneNumberConstraintErrorMessage = '有効な電話番号を入力してください';

/**
 * FAXの正規表現
 */
export const faxRegExp = new RegExp(/^0\d{9}$/);
export const faxLengthLimit = 10;
export const faxConstraintErrorMessage = '有効なFAX番号を入力してください';

/**
 * ユーザーIDは4文字以上20文字以内
 */
export const userIdRegExp = new RegExp(/^[a-zA-Z0-9]{4,20}$/);
export const userIdConstraintErrorMessage = '有効なIDを入力してください';
export const userIdConstraintMessage = '半角英数字の4文字以上20文字以内';

/**
 * メールアドレスの正規表現
 */
export const mailAddressRegExp = new RegExp(/^([\w!#$%&'*+\-\/=?^`{|}~]+(\.[\w!#$%&'*+\-\/=?^`{|}~]+)*|"([\w!#$%&'*+\-\/=?^`{|}~. ()<>\[\]:;@,]|\\[\\"])+")@(([a-zA-Z\d\-]+\.)+[a-zA-Z]+|\[(\d{1,3}(\.\d{1,3}){3}|IPv6:[\da-fA-F]{0,4}(:[\da-fA-F]{0,4}){1,5}(:\d{1,3}(\.\d{1,3}){3}|(:[\da-fA-F]{0,4}){0,2}))\])$/);
export const mailAddressLengthLimit = 255;
export const mailAddressConstraintErrorMessage = '有効なメールアドレスを入力してください';

/**
 * パスワードは半角大小文字英数字を1文字ずつ含む8文字以上
 */
export const passwordRegExp = new RegExp(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])[!-~]{8,}$/);
export const passwordConstraintErrorMessage = '有効なパスワードを入力してください';
export const passwordConstraintMessage = '半角大小文字英数字を1文字ずつ含む8文字以上';

/**
 * 表示名の正規表現
 */
export const nicknameRegExp = new RegExp(/^.{0,20}$/);
export const nicknameaLengthLimit = 20;
export const nicknameErrorMessage = '20文字以内';